export default {
  title: 'Notificaciones de reservas',
  label: '¿A dónde enviamos las notificaciones de reservas?',
  placeholder: 'p. ej. reservas@turestaurante.es',
  helper:
    'Sirve cualquier correo electrónico: no necesita acceso al panel. Puedes cambiarlo o añadir más después en Reservas → Configuración → Notificaciones y confirmación.',
  errors: {
    required: 'Añade un correo electrónico para recibir las notificaciones de reservas.',
    invalid: 'Introduce un correo electrónico válido, como nombre@restaurante.es.',
  },
};
